// extracted by mini-css-extract-plugin
export default {"container":"Cookie_container__tCOMo","heading":"Cookie_heading__9wxKr","cookiep":"Cookie_cookiep__mcdvg"};